var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 2.5L3.33203 5V15L8.33203 17.5",
    stroke: "#1E201C",
    strokeWidth: 1.04167
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 10H16.0522M14.1652 7.5L16.6654 10L14.1652 12.5",
    stroke: "#1E201C",
    strokeWidth: 1.04167
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2054eb2afc1fcffdc81e17ea24fe4861.svg";
export { ForwardRef as ReactComponent };